import { field } from 'redux/shelf';
import { analytics } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';
import { createAction } from 'redux-actions';
import { put, all, takeEvery } from 'redux-saga/effects';
import { tableData, chartData } from './helpers';
import { identity } from 'lodash';

export const snapshot = {
  fetchAvgOrderValue: analytics({
      metrics: ['purchase:avgOrderValue'], dimensions: ['time:day']
  })(chartData('avgOrderValue')),

  fetchUsers: analytics({
      metrics: ['pageview:users'], dimensions: ['time:day']
  })(chartData('users')),

  fetchVisits: analytics({
    metrics: ['pageview:sessions'], dimensions: ['time:day']
  })(chartData('visits')),

  fetchRevenue:analytics({
    metrics: ['purchase:orderRevenue'], dimensions: ['time:day']
  })(chartData('revenue')),

  fetchProductsSold:analytics({
    metrics: ['purchase:lineItemCount'], dimensions: ['time:day']
  })(chartData('productsSold')),

  fetchRevenueDistributions:analytics({
    metrics: ['purchase:orderRevenue'], dimensions: ['purchase:source']
  })(tableData('revenueDistributions')),

  fetchOutOfTotal:analytics({
    metrics: ["purchase:orderRevenue", "purchase:orderCount", "purchase:quantity"],
    dimensions: ["purchase:withFindify"]
  })(tableData('outOfTotal')),
}

export const search = {
  fetchSearchesByVolume: analytics({
    metrics: ["search:conversionRate", "search:sessions", "purchase:orderCount", "purchase:orderRevenue"],
    dimensions: ["search:query"],
    sort: [
      {"attribute": "search:sessions", "order": "desc"},
      {"attribute": "search:conversionRate", "order": "desc"},
      {"attribute": "purchase:orderRevenue", "order": "desc"}
    ],
    filters: {
      "type": "and",
      "children": [
        {
          "type": "clause",
          "operator": ">",
          "attribute": "search:nbHits",
          "value": 0
        }
      ]
    },
    limit: 10
  })(tableData('searchesByVolume')),

  fetchTop0Results: analytics({
    metrics: ['search:count'],
    dimensions: ['search:query'],
    sort: [{"attribute": "search:count", "order": "desc"}],
    filters: {
      "type":"and",
      "children":[
        {
          "type": "clause",
          "operator": "=",
          "attribute": "search:nbHits",
          "value": 0
        }
      ]
    },
    limit: 10
  })(tableData('top0Results')),

  fetchTopPartialMatches: analytics({
    metrics: ["search:conversionRate", "search:count", "purchase:orderCount", "purchase:orderRevenue"],
    dimensions: ['search:query'],
    sort: [{"attribute": "search:count", "order": "desc"}],
    filters: {
      "type":"and",
      "children":[
        {
          "type": "clause",
          "operator": "=",
          "attribute": "search:queryType",
          "value": "or"
        },
        {
          "type": "clause",
          "operator": ">",
          "attribute": "search:nbHits",
          "value": 0
        }
      ]
    },
    limit: 10
  })(tableData('topPartialMatches')),

  fetchTopFilters: analytics({
    metrics: ['filter:count'],
    dimensions: ["filter:name", "filter:value", "filter:fromValue", "filter:toValue"],
    sort: [{"attribute": "filter:count", "order": "desc"}],
    filters: {"type": "clause","operator": "=","attribute": "filter:source", "value": 'search-results'},
    limit: 10
  })(tableData('topFilters'))
}


export const collections = {
  fetchCollectionsBySlot: analytics({
    metrics: ["smart-collection:conversionRate", "smart-collection:sessions", "purchase:orderCount", "purchase:orderRevenue"],
    dimensions: ["smart-collection:slot"],
    sort: [
      {"attribute": "smart-collection:sessions", "order": "desc"},
      {"attribute": "smart-collection:conversionRate", "order": "desc"},
      {"attribute": "purchase:orderRevenue", "order": "desc"}
    ],
    limit: 10
  })(tableData('collectionsBySlot')),

  fetchCollectionsByTraffic: analytics({
    metrics: ['smart-collection:sessions'],
    dimensions: ['smart-collection:slot'],
    sort: [{"attribute": "smart-collection:sessions",  "order": "desc"}],
    limit: 10
  })(tableData('collectionsByTraffic')),

  fetchFilters: analytics({
    metrics: ['filter:count'],
    dimensions: ["filter:name", "filter:value", "filter:fromValue", "filter:toValue"],
    sort: [{"attribute": "filter:count", "order": "desc"}],
    filters: {"type": "clause","attribute": "filter:source","operator": "=","value": "smart-collection"},
    limit: 10
  })(tableData('filters'))
}

export const recommendations = {
  fetchPerformance: analytics({
    metrics: [
      "recommendation:conversionRate",
      "recommendation:sessions",
      "purchase:orderCount",
      "purchase:orderRevenue",
    ],
    dimensions: [
      "recommendation:widgetType",
      "recommendation:slot",
    ],
    limit: 100
  })(tableData('performance')),
}

export const setGlobalRange = createAction('analytics.setGlobalRange', identity, (_, page) => page);

export const actions = {
  snapshot,
  search,
  collections,
  recommendations
};

export const reducer = createReducer({
  ...snapshot,
  ...search,
  ...collections,
  ...recommendations
} , {
  [setGlobalRange]: (s, { payload }) => ({ ...s, globalRange: payload })
});

export const saga = [
  (function*() {
    yield takeEvery(setGlobalRange, function*({ payload, meta }) {
      yield all(Object.keys(actions[meta]).map(key => 
        put(actions[meta][key]({ dates: [payload] }))
      ))
    })
  })()
]
